import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Apis from "services/api";

const Maintenance: React.FC = () => {
 const { t } = useTranslation();
 const navigate = useNavigate();

 useEffect(() => {
  const checkMaintenanceStatus = async () => {
   try {
    const response = await Apis.getHealth();
    // If health check returns 200, maintenance mode has ended
    if (response.status === 200) {
     navigate("/");
    }
   } catch (error) {
    // If health check fails, assume maintenance mode is still active
    // Stay on maintenance page
   }
  };

  // Check on mount and when page is reloaded
  checkMaintenanceStatus();
 }, [navigate]);

 return (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
   <div className="text-center px-4 py-8 max-w-md mx-auto">
    <div className="mb-8">
     <svg
      className="mx-auto h-24 w-24 text-gray-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
     >
      <path
       strokeLinecap="round"
       strokeLinejoin="round"
       strokeWidth={2}
       d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path
       strokeLinecap="round"
       strokeLinejoin="round"
       strokeWidth={2}
       d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
     </svg>
    </div>
    <h1 className="text-4xl font-bold text-gray-900 mb-4">
     {t("maintenance.title")}
    </h1>
    <p className="text-lg text-gray-600 mb-8">
     {t("maintenance.message")}
    </p>
    <div className="inline-block h-1 w-20 bg-gray-300 rounded"></div>
   </div>
  </div>
 );
};

export default Maintenance;
